import { CreatePageLayout } from 'framework/ui/layout';
import { useWasteService } from 'domain/shared/waste';
import { CreateForm, FormFieldsData } from 'framework/form';
import CreateWasteBreadcrumbs from './Breadcrumbs';
import WasteForm from '../WasteForm';
import { useWasteUrl } from 'domain/shared/waste';

const CreateWastePage = () => {
  const { create, getValidationSchema } = useWasteService();
  const { getListUrl } = useWasteUrl();

  return (
    <CreateForm
      submitFormFunc={create as (values: FormFieldsData) => Promise<object | void>}
      afterSubmit={{
        redirect: getListUrl(),
        message: 'You are awesome! The Waste has been successfully created.',
      }}
      getValidationSchemaFunc={getValidationSchema}
    >
      <CreatePageLayout title="Create: Waste" breadcrumbs={<CreateWasteBreadcrumbs />}>
        <WasteForm />
      </CreatePageLayout>
    </CreateForm>
  );
};

export default CreateWastePage;
